import { render } from "./friendly-captcha-submit-button.vue?vue&type=template&id=4818b6b2"
import script from "./friendly-captcha-submit-button.vue?vue&type=script&lang=js"
export * from "./friendly-captcha-submit-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__